export default {
  ROOT: '/',
  LOGIN: '/login',
  STATIONS_MAP: '/map',
  STATIONS: '/stations',
  ADD_STATION: '/stations/new',
  STATION: '/stations/:id/:action',
  USERS: '/users',
  ADD_USER: '/users/new',
  MODIFY_USER: '/users/:id',
  USER: '/users/:id/:action',
  STATIONS_USERS_GROUPS: '/groups',
  ADD_STATIONS_USERS_GROUP: '/groups/new',
  STATIONS_USERS_GROUP: '/groups/:id/:action',
  SATELLITES: '/satellites',
  ADD_SATELLITE: '/satellites/new',
  SATELLITE: '/satellites/:id/:action',
  PROFILE: '/profile',
  RESET_PASSWORD: '/recover-password',
  RBV3STATIONS: '/rbv3s',
  RBV3STATION: '/rbv3s/:id',
  SECTION: '/section',
  SUBMENU_1: '/submenu1',
  SUBMENU_2: '/submenu2',
};
